
<template>
  <v-container fluid class="px-5 pt-3">
    <!-- <base-breadcrumb></base-breadcrumb> -->
    <v-row class="pa-3" align='center'>
      <span class="title font-weight-bold">{{ $t('templates.templates') }}</span>
      <v-spacer></v-spacer>
      <v-btn color="primary" elevation="0" small class="text-capitalize font-weight-bold" style="border-radius: 5px;" :to="{name: 'NewTemplate'}" >
        <v-icon left small>mdi-plus</v-icon>
        {{ $t('templates.template') }}
      </v-btn>
    </v-row>

    <templates-list class="mt-5"></templates-list>

    <router-view></router-view>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'TemplateListPage',
  //mixins: [ validations ],
  components: {
    TemplatesList: () => import('@/components/templates/TemplateList.vue'),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>